import { RegistrationType, ExamType } from '@report/graphql';
import { dayjs } from '@shared/utils';
import { z } from 'zod';

const MIN_LENGTH_ARRAY = 1;

export const ExamEventOverviewReportFilterSchema = z
  .object({
    startDate: z
      .date({ message: 'กรุณาเลือก Start Date' })
      .nullable()
      .refine((val) => !!val, {
        message: 'กรุณาเลือก Start Date',
      }),
    endDate: z
      .date({ message: 'กรุณาเลือก End Date' })
      .nullable()
      .refine((val) => !!val, {
        message: 'กรุณาเลือก End Date',
      }),
    examCenter: z
      .array(
        z.object(
          {
            label: z.string(),
            value: z.string(),
          },
          { message: 'กรุณาเลือก Exam Center' },
        ),
      )
      .min(MIN_LENGTH_ARRAY, { message: 'กรุณาเลือก Exam Center' }),
    registrationType: z
      .array(
        z.object({
          label: z.string(),
          value: z.nativeEnum(RegistrationType),
        }),
        { message: 'กรุณาเลือก Registration Type' },
      )
      .min(MIN_LENGTH_ARRAY, { message: 'กรุณาเลือก Registration Type' }),
    province: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
        }),
        { message: 'กรุณาเลือก Province' },
      )
      .min(MIN_LENGTH_ARRAY, { message: 'กรุณาเลือก Province' }),
    examType: z
      .array(
        z.object({
          label: z.string(),
          value: z.nativeEnum(ExamType),
        }),
        {
          message: 'กรุณาเลือก Exam Type',
        },
      )
      .min(MIN_LENGTH_ARRAY, { message: 'กรุณาเลือก Exam Type' }),
  })
  .refine(
    (data) => {
      if (!data.startDate || !data.endDate) {
        return true; // Let individual field validation handle this
      }
      const startDate = dayjs(data.startDate);
      const endDate = dayjs(data.endDate);

      return endDate.isSameOrAfter(startDate, 'date');
    },
    {
      message: 'End Date ต้องมากกว่าหรือเท่ากับ Start Date',
      path: ['endDate'],
    },
  );

export type ExamEventOverviewReportFilterFormInput = z.input<
  typeof ExamEventOverviewReportFilterSchema
>;
export type ExamEventOverviewReportFilterFormOutput = z.output<
  typeof ExamEventOverviewReportFilterSchema
>;
